const STORAGE_KEY = "privana:pending-club-login";

function isStorageAvailable() {
  return typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";
}

export function setPendingClubLogin(info) {
  if (!isStorageAvailable()) return;
  try {
    if (!info) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    const payload = {
      ...info,
      timestamp: Date.now(),
    };
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (err) {
    console.warn("failed to set pending club login", err);
  }
}

export function clearPendingClubLogin() {
  if (!isStorageAvailable()) return;
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.warn("failed to clear pending club login", err);
  }
}

export function getPendingClubLogin() {
  if (!isStorageAvailable()) return null;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch (err) {
    console.warn("failed to parse pending club login", err);
  }
  return null;
}

export function hasPendingClubLogin() {
  return !!getPendingClubLogin();
}

export const PENDING_CLUB_LOGIN_KEY = STORAGE_KEY;
